/* @flow */
import idx from 'idx';
import React from 'react';
import { graphql } from 'react-apollo';

import AccountLinkingComposerSidebar from 'chat/components/AccountLinkingComposerSidebar';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import BoxHeader from 'components/BoxHeader';
import Button from 'components/Button';
import GET_CONTENT_SOURCE_PROVIDER_QUERY from '../queries/ContentSourceProviderQuery.gql';
import Heading from 'components/Heading';
import LoadingIndicator from 'components/LoadingIndicator';
import Text from 'components/Text';
import ToastActions from 'actions/ToastActions';
import unlinkAccountMutation from 'user/mutations/unlinkAccount.gql';

import type { ContentSourceProviderContainer } from '../queries/__generated__/ContentSourceProviderContainer';

import './styles/ContentSourceProviderPreview.scss';

type Props = {
  uuid: string,
  data: ReactApolloData<ContentSourceProviderContainer>,
  unlinkAccount: (variables: Object) => Promise<{ data: Object }>,
};

type State = {
  key: number,
};

class ContentSourceProviderPreview extends React.Component<Props, State> {
  state: State = {
    key: 0,
  };

  contentSourceProviderKey = (): ?string =>
    idx(this.props, _ => _.data.contentSourceProvider.providerKey);
  refresh = () => this.setState({ key: this.state.key + 1 });
  refreshAndReset = () => {
    const key = this.contentSourceProviderKey();
    if (key) {
      this.props
        .unlinkAccount({ variables: { provider: key } })
        .then(this.refresh)
        .catch(() => ToastActions.showErrorToast('Unable to reset. Please try again later.'));
    } else {
      this.refresh();
    }
  };
  handleLinkedContent = (e: any) => ToastActions.showSuccessToast(`Success! ${e.title}`);

  render() {
    if (this.props.data.loading) {
      return <LoadingIndicator height={500} size="medium" />;
    }

    return (
      <div className="ContentSourceProviderPreview" key={this.state.key}>
        <Box>
          <BoxHeader title="Composer Playground" />
          <BoxBody divided className="ContentSourceProviderPreview-body">
            <AccountLinkingComposerSidebar
              fetchPolicy="network-only"
              addLinkedContent={this.handleLinkedContent}
            />
          </BoxBody>
          <BoxFooter className="ContentSourceProviderPreview-BoxFooter">
            <div className="ContentSourceProviderPreview-BoxFooter-item">
              <div>
                <Heading level="3" levelStyle="5">
                  Refresh content webhooks
                </Heading>
                <Text>
                  Manually refresh the playground after saving your content webhook changes.
                </Text>
              </div>
              <Button level="secondary" onClick={this.refresh}>
                Refresh
              </Button>
            </div>
            <div className="ContentSourceProviderPreview-BoxFooter-item">
              <div>
                <Heading level="3" levelStyle="5">
                  Reset authentication
                </Heading>
                <Text>If you’ve linked an account with OAuth it will be un-linked.</Text>
              </div>
              <Button level="secondary" onClick={this.refreshAndReset}>
                Reset
              </Button>
            </div>
          </BoxFooter>
        </Box>
      </div>
    );
  }
}

const withUnlinkAccountMutation = graphql(unlinkAccountMutation, { name: 'unlinkAccount' });

const withTheContentSourceProvider = graphql(GET_CONTENT_SOURCE_PROVIDER_QUERY, {
  options: ({ uuid }) => ({
    fetchPolicy: 'cache-only',
    variables: { uuid },
  }),
});

export { ContentSourceProviderPreview };
export default withUnlinkAccountMutation(
  withTheContentSourceProvider(ContentSourceProviderPreview)
);
